import React, { useEffect, useState } from 'react';
import { History } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { fmtDate } from '../../lib/dates';

// Review log: every run with the real result of each source (reused checks are marked)
export const WatchHistory = ({ refreshKey, names = {} }) => {
  const { api } = useAuth();
  const [runs, setRuns] = useState([]);
  useEffect(() => { api.get('/watched-laws/history').then((r) => setRuns(r.data.runs)).catch(() => {}); }, [refreshKey]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <section data-testid="watch-history" className="flex flex-col gap-3">
      <h2 className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-slate-400"><History className="h-4 w-4" />Historial de revisiones</h2>
      {!runs.length && <p className="text-sm text-slate-500">Todavía no hay revisiones registradas.</p>}
      {runs.map((r) => (
        <div key={r.id} data-testid="watch-history-run" className="rounded-xl border border-slate-800 bg-slate-900/40 p-3 text-xs">
          <p className="text-slate-300">{fmtDate(r.started_at, true)} · {r.trigger === 'manual' ? 'Revisión manual' : 'Revisión programada'}</p>
          <p className={r.diario_oficial.ok ? 'text-emerald-300' : 'text-rose-300'}>Diario Oficial: {r.diario_oficial.ok ? 'leído' : `falló (${r.diario_oficial.error || 'sin detalle'})`}</p>
          <p className="mt-1 flex flex-wrap gap-x-3 gap-y-1 text-slate-400">
            {r.norms.map((n) => <span key={n.norm_id} className={n.ok ? 'text-emerald-300/80' : 'text-rose-300'}>{names[n.norm_id] || n.norm_id}: {n.ok ? `BCN ok ${fmtDate(n.at, true)}${n.reused ? ' (consulta reciente reutilizada)' : ''}` : `BCN falló: ${n.error}`}</span>)}
          </p>
        </div>
      ))}
    </section>
  );
};
